var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "configuration-page" } },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("user userConfiguration.title")))]),
      _c("User-ChangePasswordCard"),
      _c("User-ApiVersionCard"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }